/**
 * A fresh `Idempotency-Key` for a job-starting POST (REF-6702). The BE REPLAYS the original job for a repeated key — even a dead one —
 * so a key may be reused ONLY for a transparent re-send of the very same request after the POST itself failed (network error / timeout).
 * Anything the user starts again (Retry on a job that never started or failed, "Retry failed items", a second submit) is a new request
 * and gets a new key.
 */
export const newIdempotencyKey = (): string => {
  const c = typeof globalThis !== "undefined" ? (globalThis as { crypto?: Crypto }).crypto : undefined;
  if (c?.randomUUID) return c.randomUUID();

  // Very old browsers / non-secure contexts: RFC 4122 v4 shape from Math.random (uniqueness is all the BE needs here).
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (ch) => {
    const r = Math.floor(Math.random() * 16);

    return (ch === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
};

/** axios config carrying the key, or an empty config when there is none. */
export const idempotencyConfig = (key?: string) => (key ? { headers: { "Idempotency-Key": key } } : {});
